import { createContext, useContext } from 'react';
import { WeavePopNotification } from '@frontend/types';

export const MuteAction = createContext<((type: WeavePopNotification['type']) => void) | undefined>(undefined);

export const useMuteAction = () => {
  const context = useContext(MuteAction);

  return context;
};

export const MuteActionProvider = MuteAction.Provider;
